import { uniqBy } from 'lodash';
import { DeviceStatusAirConnectAPIResponse } from '../deviceStatus.model';
import getGatewayOffline from './getGatewayOffline';

function getAirConnectNodeError(
  data: DeviceStatusAirConnectAPIResponse[] | undefined
) {
  const gatewayErrors =
    getGatewayOffline(data)?.map((item) => item.deviceID) ?? [];

  return (
    data &&
    uniqBy(
      data
        ?.filter((item) => !gatewayErrors.includes(item.deviceID))
        .filter((item) => item.lastResponseState === 'ERROR')
        ?.filter((item) => item.type === 1),
      'deviceID'
    )
  );
}

export default getAirConnectNodeError;
